import { apiSlice } from "app/api/apiSlice"


export const healtProfilesApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['healthProfiles'],
    endpoints: builder => ({
        // GET All
        getHealthProfiles: builder.query({
            query: () => {
                return {
                    url: 'health/profiles',
                    method: 'GET'
                }
            },
            keepUnusedDataFor: 5,
            providesTags: ['healthProfiles']
        }),
         // GET Detail
        getHealthProfileDetail: builder.query({
            query: (profileGuid) => {
                return {
                    url: 'health/profile',
                    method: 'GET',
                    params: {profileGuid: profileGuid}
                }
            },
            keepUnusedDataFor: 5,
            providesTags: ['healthProfiles']
        }),
        saveHealthProfile: builder.mutation({
            query: (newOrUpdatedProfile) => {
                return {
                    url: 'health/profile',
                    method: 'POST',
                    body: newOrUpdatedProfile
                }
            },
            invalidatesTags: ['healthProfiles']
        }),
         // DELETE Profile
         deleteHealthProfile: builder.mutation({
            query: (profileGuid) => {
                return {
                    url: 'health/profile',
                    method: 'DELETE',
                    params: {profileGuid: profileGuid}
                }
            },
            invalidatesTags: ['healthProfiles']
        }),
    })
})

export const {
    useGetHealthProfilesQuery,
    useGetHealthProfileDetailQuery,
    useSaveHealthProfileMutation,
    useDeleteHealthProfileMutation
} = healtProfilesApiSlice